module.exports = __webpack_public_path__ + "static/media/thumbnail-exterior.610c3f8a.jpeg";